var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vue-table-loader"}},[(_vm.isLoaded)?_c('div',{staticClass:"vue-table-loader master-loader"},[_c('span',{staticClass:"fa fa-cog fa-spin fa-3x"}),_vm._v(" "),_c('div',{staticClass:"dashboard-bg"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }